export const getLabelByField = field => (
	marketingFields.find(f => f.field === field) ? marketingFields.find(f => f.field === field).label : field
);

export const marketingFields = [
  { label: "Id", field: "Id" },

  { label: "Owner", field: "OwnerId" },
  { label: "Marketing Owner", field: "Owner.Name", isVisible: true }, // ✅ added
  { label: "Marketing Activity", field: "Name", isVisible: true, isDefault: true },

  { label: "Account Name", field: "Account_Name__r.Name", isVisible: true },
  { label: "Unique Identifier", field: "Unique_Identifier__c", isVisible: true },

  { label: "Event Date", field: "Event_date__c", isVisible: true, isDefault: true },
  { label: "Status", field: "Status__c", isVisible: true, isDefault: true },

  { label: "Category", field: "Category__c", isVisible: true },
  { label: "Event Type", field: "Event_Type__c", isVisible: true, isDefault: true },

  { label: "Leading Cloud", field: "Leading_Cloud__c", isVisible: true, isDefault: true },
  { label: "Description", field: "Description__c", isVisible: true },

  { label: "Related Funds", field: "Related_Funds__c", isVisible: true },
  { label: "Related Campaign", field: "Related_Campaign__c", isVisible: true },

  { label: "Next Step", field: "Next_step__c", isVisible: true },
  { label: "Next Step Date", field: "Next_step_date__c", isVisible: true },
  { label: "Next Step POC", field: "Next_step_POC__r.Name", isVisible: true },
  { label: "Next Step Owner", field: "Next_step_Owner__r.Name", isVisible: true },

  { label: "Created By", field: "CreatedBy.Name", isVisible: true },
  { label: "Last Modified By", field: "LastModifiedBy.Name", isVisible: true }
];
export const getDefaultFields = () => marketingFields.filter(f => f.isDefault);
export const getDisplayFields = (isDefault=false,keys = null) => {
  const visibleFields = marketingFields
  .filter(f => f.isVisible)
  .filter(f => isDefault ? f.isDefault : true);
;

  if (!keys||keys.length==0) return visibleFields;

  return keys
    .map(key => visibleFields.find(f => f.field === key))
    .filter(Boolean);
};

 const dashboardReportFileds =['Id', 'Name', 'Account_Name__r.Name', 'Status__c', 'Event_date__c']
export const getDashboardDisplayFields = (isDefault=false,keys = null,) => {
  const visibleDashboardFields = dashboardReportFileds
    .map(field => marketingFields.find(f => f.field === field))
    .filter(Boolean)
    .filter(f => isDefault ? f.isDefault :true)
    .map(f => ({ ...f, isVisible: true }));

  if (!keys||keys.length==0) return visibleDashboardFields;

  return keys
    .map(key => visibleDashboardFields.find(f => f.field === key))
    .filter(Boolean);
};
